import MainTable from './MainTable';
export default MainTable;
